import { render, staticRenderFns } from "./user-role.vue?vue&type=template&id=63e99382&scoped=true"
import script from "./user-role.ts?vue&type=script&lang=ts&external"
export * from "./user-role.ts?vue&type=script&lang=ts&external"
import style0 from "./user-role.vue?vue&type=style&index=0&id=63e99382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e99382",
  null
  
)

export default component.exports